export const REMOVING_SCHEDULED_EMAILS_API_ERROR = 'API Error removing scheduled email';
export const FETCHING_SCHEDULED_EMAILS_API_ERROR = 'API Error fetching scheduled emails';

export const SCHEDULED_EMAILS_DATA_LOADING_TEXT = {
    id: 'oe.website.scheduledEmailsDataLoading',
    description: 'Placeholder about loading scheduled emails data',
    defaultMessage: 'Loading Scheduled Emails data...'
};

export const ADD_SCHEDULED_EMAIL_TEXT = {
    id: 'oe.websiteTab.addScheduledEmail',
    description: 'Button text',
    defaultMessage: '+ Add New'
};

export const NEW_SCHEDULED_MEETING_EMAIL_TEXT = {
    id: 'oe.websiteTab.newScheduledEmailMeeting',
    description: 'Button text',
    defaultMessage: 'New Scheduled Email Meeting'
};

export const EDIT_SCHEDULED_MEETING_EMAIL_TEXT = {
    id: 'oe.websiteTab.editScheduledEmailMeeting',
    description: 'Button text',
    defaultMessage: 'Configure Scheduled Email Meeting'
};

export const CONTINUE_BUTTON_TEXT = {
    id: 'oe.websiteTab.continueButtonText',
    description: 'Button text',
    defaultMessage: 'Continue'
};

export const REMOVE_EMAIL_TEXT = {
    id: 'oe.websiteTab.removeEmail',
    description: 'Button label',
    defaultMessage: 'Remove Email'
};

export const REMOVE_THIS_EMAIL_TEXT = {
    id: 'oe.alerts.removeThisEmail',
    description: 'Alert message',
    defaultMessage: 'remove this email'
};

export const ARE_YOU_SURE_TEXT = {
    id: 'oe.alerts.areYouSure',
    description: 'Alert message',
    defaultMessage: 'Are you sure you want to'
};

export const CONFIGURE_EMAIL_TEXT = {
    id: 'oe.emailsForm.configureEmail',
    description: 'Alert message',
    defaultMessage: 'Configure Email'
};